import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import type { UnregisterCallback } from 'history';
import { useHistory } from 'react-router';
import type { RequestOptions } from 'searchkit';
import { history } from 'instantsearch.js/es/lib/routers';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_REQUEST_OPTIONS } from '@uncinc/react-searchkit';

import { SearchAllContent } from '../../components';
import { DEFAULT_LANGUAGE } from '../../config/constants';

import './style.scss';

const Search = () => {
  const { t } = useTranslation();

  const routerHistory = useHistory();
  const removeHistoryListener = useRef<UnregisterCallback>();
  // @ts-ignore
  const langcode = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']), DEFAULT_LANGUAGE);

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  const requestOptions: RequestOptions = {
    getBaseFilters: () => [
      {
        bool: {
          must: {
            term: {
              langcode,
            },
          },
        },
      },
    ],
    ...DEFAULT_REQUEST_OPTIONS,
  };

  return (
    <div className="Search">
      <Container>
        <SearchAllContent
          routing={routing}
          requestOptions={requestOptions}
        >
          <div className="row">
            <div className="col-12 col-lg-9">
              <h1 className="Search__title">{t('pages.search.title')}</h1>

              <p className="Search__body label--regular">
                {t('pages.search.body')}
              </p>
            </div>

            <div className="col-12">
              <SearchAllContent.SearchBar />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-4 Search__facets">
              <SearchAllContent.Facets />
              <SearchAllContent.ActiveFacets />
            </div>

            <div className="col-12 col-lg-8">
              <div className="Search__stats">
                <SearchAllContent.Stats />
                <SearchAllContent.SortBy />
              </div>

              <SearchAllContent.Results />
              <SearchAllContent.Pagination />
            </div>
          </div>
        </SearchAllContent>
      </Container>
    </div>
  );
};

export default Search;
